<template>
  <div class="cart">
    <div class="cart-wrap">
      <div class="items">
        <div class="item" v-for="item in cart" :key="item.product.id">
          <p>{{ amount(item) }}</p>
          <p class="item-name">{{item.product.name}}</p>
          <p>{{ getRowPrice(item) }}</p>
          <p class="item-remove" @click="removeFromCart(item)">
             <img src="https://queenslabcdn.blob.core.windows.net/odt/kryss_thin.svg" alt="rmeove"/>
          </p>
        </div>
      </div>

      <div class="price">
        <div class="subtotal">
          <p>Subtotal</p>
          <p>{{ currencyFormatter(subTotalPrice, "SEK").replace("kr", "SEK") }}</p>
        </div>
        <div class="shipping">
          <p>Shipping</p>
          <p>{{ shippingCost }}</p>
        </div>
        <div class="total">
          <p>Total</p>
          <p>{{ currencyFormatter(totalCost, "SEK").replace("kr", "SEK") }}</p>
          <p v-if="!taxDeducted" class="tax">VAT included</p>
          <p v-else class="tax">VAT deducted</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>


export default {
  computed: {
    cart () {
      return this.$store.getters['CART/CART']
    },
    subTotalPrice () {
      let price = 0      
      this.cart.forEach(item => {
        price += (item.product.price * item.amount)
      })
      if (!this.taxDeducted)  {
        return price
      } else {
        return price * 0.8
      }
    },
    taxDeducted () {
      let zone = this.$store.getters['SHIPPING/SHIPPING_ZONE']
      if (zone.taxDeducted === undefined) return false
      return zone.taxDeducted
    },
    shippingCost () {
      return this.calculateShippingCost();
    },
    totalCost () {
      let shippingCost = 0
      let zone = this.$store.getters['SHIPPING/SHIPPING_ZONE']
      if (zone.price !== undefined) 
        shippingCost = zone.price

      var total = this.subTotalPrice + shippingCost;

      return total;
    }
    
  },
  methods: {
    amount(item) {
      return item.amount;
    },
    calculateShippingCost () {
        let zone = this.$store.getters['SHIPPING/SHIPPING_ZONE']
        if (zone.price === undefined) return 0;
        return this.currencyFormatter(zone.price, zone.currency).replace("kr", "SEK"); 
    },
    getRowPrice (item) {
      var totalRowPrice = item.product.price * item.amount;
      return this.currencyFormatter(totalRowPrice, item.product.currency).replace("kr", "SEK");  
    },
    currencyFormatter(price, currency) {
      var localization = 'sv-SE';
      return new Intl.NumberFormat(localization, {
          style: 'currency',
          currency: currency ? currency : "SEK",
          minimumFractionDigits: 0
      })
      .format(price);
    },
    removeFromCart (item) {
      this.$store.dispatch('CART/REMOVE', item.product)
    },
    
  }
}
</script>

<style lang="postcss" scoped>
  .item-remove {
    margin-top: 15px;
    font-size: 20px;
    margin-left: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item-remove img {
    display: block;
    width: 15px;
    height: 15px;
  }
  .cart-wrap {
    width: 100%;
    height: 100%;
    margin: auto;
    border-bottom: 1px solid #777;
    border-left: 1px solid #777;
    border-right: 1px solid #777;
  }
  h3 {
    text-align: center;
  }
  .items {
    border-top: 1px solid #777;
  }
  .item {
    padding: .5em 1em;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }


  .item-name {
    text-align: left;
    width: 60%;
  }

  .item-remove {
    cursor: pointer;
  }

  .price {
    border-top: 1px solid #777;
    padding-top: 1.5em;
    padding-bottom: 6%;
  }

  .subtotal, 
  .shipping,
  .total {
    padding: 0em 2.9em 0em 2.25em;
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
  }

  .total {
    flex-flow: row wrap;
  }
  .total p {
    margin-bottom: 0;
  }

  .total .tax {
    display: block;
    text-align: right;
    width: 100%;
    margin: 0;
    padding: 0;
    font-size: .8em;
  }

  


@media screen and (max-width: 768px) {
    h3 {
      font-size: 1.8em;
    }
      
  .cart-wrap {width: 100%;}
  
}
</style>

